// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__10Fso","footer":"ChangeClinic_footer__1IPE1"};